<h2>契約共通情報</h2>

<form [formGroup]="ctrCommonInfo">
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="fill"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
            <mat-label>ＷＴ卸利用事業者</mat-label>
            <input matInput formControlName="resaleBusAname" class="font-color-display-only" autocomplete="off"
                readonly />
        </mat-form-field>

        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
            <mat-label>ＷＴ卸利用事業者受付番号</mat-label>
            <input matInput formControlName="wtorishiserviceproviderAcceptancenumber" autocomplete="off"
                maxlength="13" />
            <mat-hint></mat-hint>
        </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
            <mat-label>料金プラン</mat-label>
            <mat-select formControlName='wtoroshiContractclassfyCode' id="prdCode" required>
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let type of productList" [value]="type.value">
                    {{type.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline"
            class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
            <mat-label>適用年月日</mat-label>
            <input matInput [matDatepicker]="keiyakuHenkoYmd" formControlName="keiyakuHenkoYmd" autocomplete="off"
                required>
            <mat-datepicker-toggle matSuffix [for]="keiyakuHenkoYmd"></mat-datepicker-toggle>
            <mat-datepicker #keiyakuHenkoYmd></mat-datepicker>
        </mat-form-field>

        <div class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-ml-[40px]">
            <mat-checkbox class="check-box" color="primary" formControlName="appliedAtTurnOn">開栓時適用</mat-checkbox>
        </div>
    </div>

    <div *ngIf="futaiList.length>0" id="futaiInfo">
        <div>
            <mat-form-field appearance="outline"
                class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>付帯契約</mat-label>
                <mat-select id="futaiCode" formControlName='wtoroshiGoodscode'>
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let type of futaiList" [value]="type.value">
                        {{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div>
        <table>
            <tr>
                <td class="kiki-cell"><mat-label>給湯</mat-label></td>
                <td class="kiki-cell"><mat-label>厨房</mat-label></td>
                <td class="kiki-cell"><mat-label>暖房</mat-label></td>
            </tr>
            <tr>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="highefficiencyWaterheater">高効率給湯器</mat-checkbox></td>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="kitchenequipment">厨房機器</mat-checkbox></td>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="yukadanbo">床暖房</mat-checkbox></td>
            </tr>
            <tr>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="etcWaterheater">その他給湯器</mat-checkbox></td>
                <td class="kiki-cell"></td>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="bathroomheatingDryer">浴室暖房乾燥機</mat-checkbox></td>
            </tr>
            <tr>
                <td class="kiki-cell"></td>
                <td class="kiki-cell"></td>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="etcHeatmachine">その他暖房機</mat-checkbox></td>
            </tr>
            <tr>
                <td class="kiki-cell"><mat-label>空調</mat-label></td>
                <td class="kiki-cell"><mat-label>コージェネ</mat-label></td>
                <td class="kiki-cell"></td>
            </tr>
            <tr>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="airconditioning">空調機器</mat-checkbox></td>
                <td class="kiki-cell"><mat-checkbox class="check-box" color="primary"
                        formControlName="cogenerationDevice">コージェネ機器</mat-checkbox></td>
                <td class="kiki-cell"></td>
            </tr>
        </table>
    </div>
</form>

<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right btn_area_pb0">
        <button type="submit" mat-raised-button color="primary" class="btn" (click)="onSubmit()"
            [disabled]="ctrCommonInfo.invalid" *ngIf="createDispFlg" mat-raised-button>登録</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right btn_area_pb0">
        <button type="button" mat-raised-button color="primary" class="btn" id="edit" (click)="onEdit()"
            *ngIf="editDispFlg">編集</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right btn_area_pb0">
        <button type="button" mat-raised-button color="primary" class="btn" id="delete" (click)="onDelete()"
            *ngIf="deleteDispFlg">取消</button>
    </mat-card-actions>
</div>
<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
    <mat-card-actions class="btn_area_right btn_area_pt0">
        <button type="button" mat-raised-button color="primary" class="btn" id="cancel" (click)="onCancel()"
            *ngIf="cancelDispFlg">キャンセル</button>
    </mat-card-actions>
    <mat-card-actions class="btn_area_right btn_area_pt0">
        <button type="button" mat-raised-button color="primary" class="btn" id="close" (click)="onClose()"
            *ngIf="closeDispFlg">閉じる</button>
    </mat-card-actions>
</div>